module.exports = __webpack_public_path__ + "images/landing/banner/help-img-5.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/landing/banner/help-img-5.png
// module id = wWYA
// module chunks = 118